import './styles.scss';

import { ReactElement, useMemo } from 'react';

import AutomationTrips from '@/features/Automation/pages/AutomationTrips';
import { useParams } from 'react-router-dom';

const Automation = (): ReactElement => {
  const { ['sub-route']: subRoute } = useParams<Record<string, string>>();

  const Content = useMemo((): ReactElement => {
    switch (subRoute) {
      case 'trips':
      default:
        return <AutomationTrips />;
    }
  }, [subRoute]);

  return Content;
};

export default Automation;
